import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";
import { getUserType } from "src/utils/localStorageHelper";

export const getRegularClassSchedules = ({ id, ...params }) => {
  const userType = getUserType();

  return api.get(`${userType}/regular-class-schedules/${id}`, { params });
};

export const getRegularClassScheduleQueryOptions = params => {
  return queryOptions({
    queryKey: ["regular-class-schedules", params],
    queryFn: () => getRegularClassSchedules(params),
  });
};

export const useRegularClassScheduleQuery = ({
  queryConfig = {},
  ...params
}) => {
  return useQuery({
    ...getRegularClassScheduleQueryOptions(params),
    ...queryConfig,
  });
};
